import { render, staticRenderFns } from "./Carregando.vue?vue&type=template&id=89b68650"
import script from "./Carregando.vue?vue&type=script&lang=js"
export * from "./Carregando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports